import { useEffect, useState } from "react";
import { NFCeDto, NFCeConsultaInputDto } from "../NFCe.Dto";
import {
  NFCeBuscarXML,
  NFCeConsultarSituacao,
  NFCeExcluir,
  NFCeFiltrar,
  NFCeImprimir,
} from "src/services/Fiscal.Service";
import { useSearchParams } from "react-router-dom";
import { MapearErrosServidor } from "src/hook/Functions";
import { showToast } from "src/componentes";
import moment from "moment";

const getDataInicialPadrao = () => moment().startOf("month").toDate();
const getDataFinalPadrao = () => moment().toDate();

const parseFilterDate = (dateString: string | null): Date | null => {
  if (!dateString) return null;
  const m = moment(dateString);
  return m.isValid() ? m.toDate() : null;
};

const NFCeConsultaCode = () => {
  const [data, setData] = useState<NFCeDto[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalShowPropriedades, setModalShowPropriedades] = useState(false);
  const [modalShowRelatorio, setModalShowRelatorio] = useState(false);
  const [nfce, setNFCe] = useState<NFCeDto>();
  const [searchParams, setSearchParams] = useSearchParams();

  const getFiltrosIniciais = (): NFCeConsultaInputDto => {
    const dataInicialParam = searchParams.get("dataEmissaoInicial");
    const dataFinalParam = searchParams.get("dataEmissaoFinal");
    const semDataParam = searchParams.get("semData");

    return {
      codigoStatusEnvio: searchParams.get("codigoStatusEnvio") || null,
      dataEmissaoInicial:
        semDataParam === "true"
          ? null
          : dataInicialParam
          ? parseFilterDate(dataInicialParam)
          : getDataInicialPadrao(),
      dataEmissaoFinal:
        semDataParam === "true"
          ? null
          : dataFinalParam
          ? parseFilterDate(dataFinalParam)
          : getDataFinalPadrao(),
      serie: Number(searchParams.get("serie")),
    };
  };

  const [filtros, setFiltros] = useState<NFCeConsultaInputDto>(getFiltrosIniciais);

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setLoading(true);
      await filtrar(filtros).finally(() => {
        setLoading(false);
      });
    };
    if (
      (filtros.dataEmissaoInicial !== null &&
        filtros.dataEmissaoFinal !== null) ||
      (filtros.dataEmissaoInicial === null && filtros.dataEmissaoFinal === null)
    ) {
      Load();
    }
    return () => {
      controller.abort();
    };
  }, [filtros]);

  useEffect(() => {
    const dataInicialParam = searchParams.get("dataEmissaoInicial");
    const dataFinalParam = searchParams.get("dataEmissaoFinal");
    const semDataParam = searchParams.get("semData");

    const novoFiltro: NFCeConsultaInputDto = {
      codigoStatusEnvio: searchParams.get("codigoStatusEnvio") || null,
      dataEmissaoInicial:
        semDataParam === "true"
          ? null
          : dataInicialParam
          ? parseFilterDate(dataInicialParam)
          : getDataInicialPadrao(),
      dataEmissaoFinal:
        semDataParam === "true"
          ? null
          : dataFinalParam
          ? parseFilterDate(dataFinalParam)
          : getDataFinalPadrao(),
      serie: Number(searchParams.get("serie")),
    };

    setFiltros((prevFiltros) => {
      if (JSON.stringify(prevFiltros) === JSON.stringify(novoFiltro)) {
        return prevFiltros;
      }
      return novoFiltro;
    });
  }, [searchParams]);

  const filtrar = async (input: NFCeConsultaInputDto) => {
    await NFCeFiltrar(input)
      .then((response) => {
        if (response.data.success) {
          setData(response.data.data);
        } else {
          MapearErrosServidor(response.data.notifications, showToast);
        }
      })
      .catch((error) => {
        console.log(error);
        showToast({
          message: "Ocorreu erro ao buscar dados",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      });
  };

  const handleClickPropriedades = (value: NFCeDto) => () => {
    setModalShowPropriedades(true);
    setNFCe(value);
  };

  const onCancelModalPropriedades = () => {
    setModalShowPropriedades(false);
  };

  const onCancelModalRelatorio = () => {
    setModalShowRelatorio(false);
  };

  const handleMenuClickRelatorio = () => {
    setModalShowRelatorio(true);
  };

  const onDownloadXml = async (value: NFCeDto) => {
    setLoading(true);
    setModalShowPropriedades(false);

    try {
      const nomeArquivo = `NFCe_${value.numeroNF}`;
      const response = await NFCeBuscarXML([value.id!], nomeArquivo);
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${nomeArquivo}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao baixar XML",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMenuClickDownloadXML = async () => {
    setLoading(true);
    if (data.length === 0) {
      showToast({
        message: "Nenhuma NFCe selecionado",
        title: "Atenção",
        variant: "Warning",
      });
      setLoading(false);
      return;
    }
    try {
      const primeiro = data[0];
      const ultimo = data[data.length - 1];
      const ids = data.map((item) => item.id!);
      const nomeArquivo = `NFCe_${primeiro?.numeroNF}_${ultimo?.numeroNF}`;
      const response = await NFCeBuscarXML(ids, nomeArquivo);
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${nomeArquivo}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao baixar XML",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const onFetchStatusModalPropriedades = async (value: NFCeDto) => {
    onCancelModalPropriedades();
    setLoading(true);
    await NFCeConsultarSituacao(value.id!)
      .then((response) => {
        MapearErrosServidor(response.data.notifications, showToast);
      })
      .catch((error) => {
        showToast({
          message: "Ocorreu erro ao consultar situação",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      })
      .finally(() => setLoading(false));
  };

  const onPrintModalPropriedadesImprimir = async (value: NFCeDto) => {
    onCancelModalPropriedades();

    setLoading(true);
    await NFCeImprimir(value.id!)
      .then((response) => {
        if (response.data instanceof Blob) {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const isMobile = /Android|iPhone/i.test(navigator.userAgent);

          if (isMobile) {
            // abre o visualizador nativo
            window.open(pdfUrl, "_blank");
          } else {
            // desktop pode imprimir direto
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.src = pdfUrl;

            document.body.appendChild(iframe);

            iframe.onload = () => {
              iframe.contentWindow?.focus();
              iframe.contentWindow?.print();
            };
          }
        } else {
          MapearErrosServidor(response.data.notifications, showToast);
          return;
        }
      })
      .finally(() => setLoading(false));
  };

  const onModalPropriedadesDownloadDanfe = async (value: NFCeDto) => {
    onCancelModalPropriedades();
    setLoading(true);
    await NFCeImprimir(value.id!)
      .then((response) => {
        if (response.data instanceof Blob) {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.download = `DanfeNFCe${value.numeroNF}.pdf`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          MapearErrosServidor(response.data.notifications, showToast);
          return;
        }
      })
      .finally(() => setLoading(false));
  };

  const onModalPropriedadesShareDanfe = async (value: NFCeDto) => {
    onCancelModalPropriedades();
    setLoading(true);
    await NFCeImprimir(value.id!)
      .then(async (response) => {
        if (response.data instanceof Blob) {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          try {
            const file = new File([pdfBlob], `DanfeNFCe${value.numeroNF}.pdf`, {
              type: "application/pdf",
            });

            if (navigator.canShare?.({ files: [file] })) {
              await navigator.share({
                title: "DANFE NFC-e",
                files: [file],
              });
            } else {
              onModalPropriedadesDownloadDanfe(value);
            }
          } catch (err) {
            console.error("Erro ao compartilhar:", err);
          }
        } else {
          MapearErrosServidor(response.data.notifications, showToast);
          return;
        }
      })
      .finally(() => setLoading(false));
  };

  const onDeleteModalPropriedades = async (value: NFCeDto) => {
    setLoading(true);
    await NFCeExcluir(value.id!)
      .then((response) => {
        if (response.data.success === true) {
          filtrar(filtros);
        } else {
          MapearErrosServidor(response.data.notifications, showToast);
        }
      })
      .catch((error) => {
        console.log(error);
        showToast({
          message: "Ocorreu erro ao excluir NFCe",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelect = (eventKey?: string | null) => {
    if (eventKey) {
      const novoFiltro = new URLSearchParams(searchParams);
      if (eventKey === "99") {
        novoFiltro.delete("codigoStatusEnvio");
      } else {
        novoFiltro.set("codigoStatusEnvio", eventKey);
      }

      setSearchParams(novoFiltro, { replace: true });
    }
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const novoFiltro = new URLSearchParams(searchParams);

    if (event.target.value) {
      novoFiltro.set("serie", event.target.value);
    } else {
      novoFiltro.delete("serie");
    }

    setSearchParams(novoFiltro, { replace: true });
  };

  const formatDate = (date: any) =>
    date ? date.toLocaleDateString("pt-BR") : "Selecionar";

  const setDates = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    const novoFiltro = new URLSearchParams(searchParams);

    if (!start && !end) {
      novoFiltro.delete("dataEmissaoInicial");
      novoFiltro.delete("dataEmissaoFinal");
      novoFiltro.set("semData", "true");
    } else {
      novoFiltro.delete("semData");
      if (start) {
        novoFiltro.set("dataEmissaoInicial", moment(start).format("YYYY-MM-DD"));
      } else {
        novoFiltro.delete("dataEmissaoInicial");
      }

      if (end) {
        novoFiltro.set("dataEmissaoFinal", moment(end).format("YYYY-MM-DD"));
      } else {
        novoFiltro.delete("dataEmissaoFinal");
      }
    }

    setSearchParams(novoFiltro, { replace: true });
  };

  const datePickerTitle = () => {
    if (!filtros.dataEmissaoInicial || !filtros.dataEmissaoFinal) {
      return `Emissão`;
    }

    return `${formatDate(new Date(filtros.dataEmissaoInicial))} - ${formatDate(
      new Date(filtros.dataEmissaoFinal),
    )}`;
  };

  return {
    loading,
    data,
    handleClickPropriedades,
    modalShowPropriedades,
    nfce,
    onCancelModalPropriedades,
    onDeleteModalPropriedades,
    filtros,
    formatDate,
    handleSelect,
    setDates,
    datePickerTitle,
    handleOnChange,
    onPrintModalPropriedadesImprimir,
    onDownloadXml,
    handleMenuClickDownloadXML,
    onFetchStatusModalPropriedades,
    onModalPropriedadesDownloadDanfe,
    onModalPropriedadesShareDanfe,
    modalShowRelatorio,
    onCancelModalRelatorio,
    handleMenuClickRelatorio,
  };
};

export default NFCeConsultaCode;
